module.exports = __webpack_public_path__ + "img/Frame-46.e83ba744.svg";